// src/App.js
import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import JSONEducation from "./JSONEducation";
import SFDC247JSONView from "./SFDC247JSONView";
import JSONFormatter from "./JSONFormatter";
import JSONBeautifier from "./JSONBeautifier";
import JSONMinifier from "./JSONMinifier";
import JSONValidator from "./JSONValidator";
import JSONSchemaValidator from "./JSONSchemaValidator";
import JSONSchemaGenerator from "./JSONSchemaGenerator";
import JSONDiff from "./JSONDiff";
//import SFDC247AdvancedDiff from "./SFDC247AdvancedDiff";
import JSONDataComparator from "./JSONDataComparator";
import JSONKeyValueExtractor from "./JSONKeyValueExtractor";
import JSONPathFinder from "./JSONPathFinder";
import JSONNestedKeyExtractor from "./JSONNestedKeyExtractor";
import JSONMerge from "./JSONMerge";
import JSONKeyRenamer from "./JSONKeyRenamer";
import JSONArrayFilter from "./JSONArrayFilter";
import JSONObjectSorter from "./JSONObjectSorter";
import JSONConverter from "./JSONConverter";
import JsonToCsvConverter from "./JsonToCsvConverter";
import CsvToJsonConverter from "./CsvToJsonConverter";
import JsonToXmlConverter from "./JsonToXmlConverter";
import DiffComponent from "./DiffComponent";

const App = () => {
  const [selectedTool, setSelectedTool] = useState("JSON Education");

  const toolCategories = [
    {
      category: "Learn JSON",
      tools: {
        "JSON Education": JSONEducation,
        "SFDC247 JSON View": SFDC247JSONView,
      },
    },
    {
      category: "JSON Utilities",
      tools: {
        "JSON Formatter": JSONFormatter,
        "JSON Beautifier": JSONBeautifier,
        "JSON Minifier": JSONMinifier,
        "JSON Validator": JSONValidator,
        "JSON Schema Validator": JSONSchemaValidator,
        "JSON Schema Generator": JSONSchemaGenerator,
      },
    },
    {
      category: "JSON Data Comparison",
      tools: {
        "Diff Component": DiffComponent,
        "JSON Diff": JSONDiff,
        //"SFDC247 Advanced Diff": SFDC247AdvancedDiff,
        "JSON Data Comparator": JSONDataComparator,
        "JSON Key-Value Extractor": JSONKeyValueExtractor,
        "JSON Path Finder": JSONPathFinder,
        "JSON Nested Key Extractor": JSONNestedKeyExtractor,
      },
    },
    {
      category: "Data Transformation Tools",
      tools: {
        "JSON Merge": JSONMerge,
        "JSON Key Renamer": JSONKeyRenamer,
        "JSON Array Filter": JSONArrayFilter,
        "JSON Object Sorter": JSONObjectSorter,
      },
    },
    {
      category: "Converters",
      tools: {
        "JSON Converter": JSONConverter,
        "JSON to CSV": JsonToCsvConverter,
        "CSV to JSON": CsvToJsonConverter,
        "JSON to XML": JsonToXmlConverter,
      },
    },
  ];

  const SelectedToolComponent = toolCategories
    .flatMap((category) => Object.entries(category.tools))
    .find(([key]) => key === selectedTool)?.[1];

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <div
        style={{
          width: "250px",
          backgroundColor: "#4CAF50",
          color: "white",
          padding: "20px",
          boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
          overflowY: "auto",
        }}
      >
        <h3
          style={{
            marginBottom: "20px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          JSON Tools Suite
        </h3>
        {toolCategories.map((category) => (
          <div key={category.category} style={{ marginBottom: "20px" }}>
            <h4
              style={{
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "10px",
                borderBottom: "1px solid #ffffff",
                paddingBottom: "5px",
              }}
            >
              {category.category}
            </h4>
            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
              {Object.keys(category.tools).map((tool) => (
                <li
                  key={tool}
                  style={{
                    padding: "10px",
                    cursor: "pointer",
                    backgroundColor:
                      selectedTool === tool ? "#388E3C" : "transparent",
                    color: selectedTool === tool ? "white" : "inherit",
                    fontWeight: selectedTool === tool ? "bold" : "normal",
                    marginBottom: "5px",
                    borderRadius: "5px",
                    transition: "background-color 0.3s ease",
                    textAlign: "center",
                  }}
                  onClick={() => setSelectedTool(tool)}
                  onMouseOver={(e) => {
                    if (selectedTool !== tool) {
                      e.target.style.backgroundColor = "#66BB6A";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (selectedTool !== tool) {
                      e.target.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  {tool}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
  
      {/* Main Content Area */}
      <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
        <Header />
        <div style={{ marginTop: "20px" }}>
          <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
            {selectedTool}
          </h2>
          {SelectedToolComponent ? (
            <SelectedToolComponent />
          ) : (
            <div>Tool not found</div>
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default App;